/* Mr. Zhu's global UI */
(function () {
  "use strict";

  const header = document.querySelector('.mz-header');
  if (header) {
    const onScroll = () => header.classList.toggle('mz-header--scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const menu = document.getElementById('MzMobileMenu');
  if (menu) {
    const open = () => { menu.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    const close = () => { menu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    document.querySelectorAll('[data-mz-menu-open]').forEach(b => b.addEventListener('click', open));
    document.querySelectorAll('[data-mz-menu-close]').forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  const banner = document.querySelector('[data-cookie-banner]');
  if (banner) {
    const stored = localStorage.getItem('mz-cookie-consent');
    if (!stored) banner.hidden = false;
    const dismiss = (value) => { localStorage.setItem('mz-cookie-consent', value); banner.hidden = true; };
    banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => dismiss('accepted'));
    banner.querySelector('[data-cookie-reject]')?.addEventListener('click', () => dismiss('rejected'));
  }

  const productJsonEl = document.querySelector('[data-product-json]');
  if (productJsonEl) {
    let product;
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) { product = null; }
    const select = document.getElementById('VariantSelect');
    const priceEl = document.querySelector('[data-price]');
    const addLabel = document.querySelector('[data-add-label]');
    const variantButtons = document.querySelectorAll('.mz-variant');

    function selectedOptions() {
      const map = {};
      variantButtons.forEach(b => { if (b.classList.contains('is-active')) map[b.dataset.optionName] = b.dataset.optionValue; });
      return map;
    }
    function findVariant(opts) {
      if (!product) return null;
      return product.variants.find(v => product.options.every((name, i) => opts[name] === v.options[i]));
    }
    function formatMoney(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
    function updateVariant() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      if (!variant) return;
      if (select) select.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addLabel) addLabel.textContent = 'Add to cart - ' + formatMoney(variant.price);
    }
    variantButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        variantButtons.forEach(b => { if (b.dataset.optionName === btn.dataset.optionName) b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateVariant();
      });
    });
  }

  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    const wrap = e.target.closest('.mz-qty');
    if (!wrap) return;
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    const current = parseInt(input.value, 10) || 0;
    input.value = Math.max(parseInt(input.min || '0', 10), current + (inc ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('.mz-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.mz-product__main');
      if (!main) return;
      const img = thumb.querySelector('img');
      if (!img) return;
      main.innerHTML = '';
      const clone = img.cloneNode(true);
      clone.removeAttribute('loading');
      clone.src = img.dataset.bigSrc || img.src;
      main.appendChild(clone);
      document.querySelectorAll('.mz-thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  document.querySelector('[data-sort]')?.addEventListener('change', (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    window.location.href = url.toString();
  });
  document.querySelectorAll('#CollectionFilters input').forEach(inp => {
    inp.addEventListener('change', () => {
      const form = document.getElementById('CollectionFilters');
      const params = new URLSearchParams();
      form.querySelectorAll('input').forEach(i => {
        if (i.type === 'checkbox' && i.checked) params.append(i.name, i.value);
        else if (i.type === 'number' && i.value) params.set(i.name, i.value);
      });
      const url = new URL(window.location.href);
      const sort = url.searchParams.get('sort_by');
      url.search = params.toString();
      if (sort) url.searchParams.set('sort_by', sort);
      window.location.href = url.toString();
    });
  });
})();
